import React, { Component } from 'react'
import _ from 'lodash'

import StatusModal from 'components/statusModal'
import { Get, Post, Put } from 'utils/axios'

const partyLib = [
  { id: 1, value: 'buyer-signature' },
  { id: 2, value: 'buyer-agent-signature' },
  { id: 3, value: 'seller-signature' },
  { id: 4, value: 'seller-agent-signature' }
]

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      showStatusModal: false,
      formType: null,

      showInvalidIdentityModal: false,
      showIdentityVerification: true,
      showInitialTncModal: false, // the first tnc modal
      showSubmitFormSection: false,

      statusModalType: '',
      onClickStatusModalButton: () => {},
      statusModalMessage: '',

      partyInfo: {
        id: '',
        confirmation_form_id: '',
        signing_party: ''
      },
      confirmationContent: '', //html content
      signatureImage: null,
      companyStamp: null,
      companyStampFilename: '',
      scrollToBottom: false,
      acknowledgementCheckbox: false,
      checkedAcknowledgeCheckbox: false,
      
      htmlDivId: null,
      compDivId: null,
      referenceId: null,

      formId: null //can be confirmation or refund form id based on decoded content
    }

    load = param => this.setState({ loading: param })
    requestError = error => this.setState({
      showStatusModal: true,
      statusModalType: 'warning-custom',
      onClickStatusModalButton: () => this.setState({ showStatusModal: false }),
      statusModalMessage: error
    })
    requestSuccess = ( success, callback ) => this.setState({
      showStatusModal: true,
      statusModalType: 'positive',
      onClickStatusModalButton: () => { 
        this.setState({ showStatusModal: false })
        if ( callback ) {
          callback()
        }
      },
      statusModalMessage: success
    })

    onChangeHOC = ( val, context ) => this.setState({ [context]: val })

    identifyVerification = ( id, val ) => Post(
      `/e_processes/verify`,
      { 
        form_contact_id: id,
        identification_number: val
      },
      this.identifyVerificationSuccess,
      this.identifyVerificationError,
      this.load
    )
    identifyVerificationSuccess = payload => {
      let tempParty = _.find( partyLib, { id: payload.party_id }).value
      this.setState({ 
        showIdentityVerification: false,
        partyInfo: payload,
        showInitialTncModal: payload.status_id !== 4 && !payload.accept_tnc,
        showSubmitFormSection: true,
        referenceId: payload.form_transaction_number,
        htmlDivId: `${ tempParty }-${ payload.id }`,
        compDivId: `${ payload.party.toLowerCase() }-company-stamp-${ payload.id }`
      }, () => {
        this.getHTMLContent( payload.id )
      })
    }
    identifyVerificationError = error => this.requestError( error )

    getHTMLContent = ( id ) => Get(
      `/e_processes/get_html?form_contact_id=${ id }&form_id=${ this.state.formId }&form_type=${ this.state.formType }`,
      this.getHTMLContentSuccess,
      this.getHTMLContentError,
      this.load
    )
    getHTMLContentSuccess = payload => this.setState({ confirmationContent: payload })
    getHTMLContentError = error => this.requestError( error )

    acceptTnc = dataToSubmit => Put(
      `/e_processes/accept_tnc`,
      dataToSubmit,
      this.acceptTncSuccess,
      this.acceptTncError,
      this.load
    )
    acceptTncSuccess = payload => this.setState({ 
      showInitialTncModal: !payload.accept_tnc,
    })
    acceptTncError = error => this.requestError( error )

    sendConfirmationCode = dataToSubmit => {
      this.setState({ submitTypeId: dataToSubmit.type_id }, () => {
        Post(
          `/e_processes/send_confirmation_code`,
          { 
            ... dataToSubmit, 
            form_type: this.state.formType
          },
          this.sendConfirmationCodeSuccess,
          this.sendConfirmationCodeError,
          this.load
        )
      })
    }
    sendConfirmationCodeSuccess = () => this.setState({ showConfirmationCodeModal: true })
    sendConfirmationCodeError = error => this.requestError( error )
    
    verifyConfirmationCode = dataToSubmit => {
      if ( dataToSubmit.type_id === 3 ){
        delete dataToSubmit.reject_option_id
        delete dataToSubmit.reason
      }
      Post(
        `/e_processes/verify_confirmation_code`,
        { 
          ... dataToSubmit, 
          form_type: this.state.formType
        },
        this.verifyConfirmationCodeSuccess,
        this.verifyConfirmationCodeError,
        this.load
      )
    }
    verifyConfirmationCodeSuccess = payload => {
      let temp = this.state.submitTypeId 
      // odd number submit type id is agree.
      
      this.setState({ partyInfo: payload })
      this.requestSuccess( 
        temp % 2
          ? 'The e-signing has been submitted successfully.'
          : 'The contract has been declined.', 
        () => this.setState({ showConfirmationCodeModal: false }
      ))
    }
    verifyConfirmationCodeError = error => this.requestError( error )

    render = () => { 
      return (
        <>
          <WrappedComponent
            { ...this.props } 
            formId={ this.state.formId }
            formType={ this.state.formType }
            referenceId={ this.state.referenceId }
            submitTypeId={ this.state.submitTypeId }
            onLoadConfirmation={ this.state.loading }
            showConfirmationCodeModal={ this.state.showConfirmationCodeModal }
            htmlDivId={ this.state.htmlDivId }
            compDivId={ this.state.compDivId }
            companyStamp={ this.state.companyStamp }
            companyStampFilename={ this.state.companyStampFilename }
            signatureImage={ this.state.signatureImage }
            partyInfo={ this.state.partyInfo }
            showInvalidIdentityModal={ this.state.showInvalidIdentityModal }
            confirmationContent={ this.state.confirmationContent }
            showInitialTncModal={ this.state.showInitialTncModal }
            showSubmitFormSection={ this.state.showSubmitFormSection }
            showIdentityVerification={ this.state.showIdentityVerification }
            scrollToBottom={ this.state.scrollToBottom }
            acknowledgementCheckbox={ this.state.acknowledgementCheckbox }
            checkedAcknowledgeCheckbox={ this.state.checkedAcknowledgeCheckbox }
            onLoad={ this.state.loading }

            acceptTnc={ this.acceptTnc }
            onChangeHOC={ this.onChangeHOC }
            sendConfirmationCode={ this.sendConfirmationCode }
            verifyConfirmationCode={ this.verifyConfirmationCode }
            identifyVerification={ this.identifyVerification }/>
          <StatusModal
            isOpen={ this.state.showStatusModal }
            type={ this.state.statusModalType }
            message={ this.state.statusModalMessage ? this.state.statusModalMessage : 'You might be disconnected from the Internet, please reconnect and refresh the page to use Atlas again.' }
            onClick={ this.state.onClickStatusModalButton } />
        </>
      )
    }
  }
  return WithHOC
}

export default HOC